import React, { useEffect, useRef, useState } from 'react';
import { FaTwitter, FaDiscord } from 'react-icons/fa';
import './NavbarNew.css';
import sun from '../../assets/sun.svg';
import { WalletDialogButton, WalletMultiButton } from '@solana/wallet-adapter-material-ui';
import { setGlobalState, useGlobalState } from '../../state/index';

const NavbarNew = () => {
    const [darkMode] = useGlobalState('darkMode')
    const [mobileMenu, setMobileMenu] = useState(false);
    const [navbarHeight, setNavbarHeight] = useState(0)
    const mobileRef = useRef(null);
    const navbarRef = useRef(null);

    useEffect( () => {
        if(navbarRef.current){
            let height = navbarRef.current.offsetHeight;
            setNavbarHeight(height);
        }
        function handleClickOutside(event) {
            if (mobileRef.current && !mobileRef.current.contains(event.target)) {
              setMobileMenu(false);
            }
          }
          // Bind the event listener
          document.addEventListener("mousedown", handleClickOutside);
          return () => {
            // Unbind the event listener on clean up
            document.removeEventListener("mousedown", handleClickOutside);
          };

    }, [navbarRef, mobileRef]);

  return (
    <div ref={mobileRef} className="navbar-new-main-wrapper">
    <div ref={navbarRef} className={`navbar-new-wrapper ${darkMode ? 'navbar-dark' : 'navbar-light'}`}>
    <div className={`navbar-new-master`}>
        <a href="/">
            ToritosToons
        </a>
        <div className="navbar-new-main">
            <div className="navbar-new-links">
                <a href="/">About</a>
                <a href="/">Collection</a>
                <a href="/">FAQs</a>
                <WalletDialogButton>
                    Connect wallet
                </WalletDialogButton>
            </div>
            <div className="navbar-new-social">
                <a href="/">
                    <FaTwitter size={25}/>
                </a>
                <a href="/">
                    <FaDiscord size={25}/>
                </a>
                <button onClick={() => setGlobalState('darkMode', !darkMode)}>
                    <img className={`${darkMode ? 'darkmode-icon-dark' : 'darkmode-icon-light'}`} src={sun} alt="light-mode" />
                </button>
            </div>
        </div>
        <div onClick={() => setMobileMenu(!mobileMenu)} className="navbar-new-mobile">
            <span style={{transform: mobileMenu ? 'rotate(45deg) translate(3px, 1px)' : '', backgroundColor: darkMode ? '#fff' : '#101111'}}></span>
            <span style={{width: mobileMenu ? '0px' : '', backgroundColor: darkMode ? '#fff' : '#101111'}}></span>
            <span style={{transform: mobileMenu ? 'rotate(-45deg) translate(-1px, -1px)' : '', backgroundColor: darkMode ? '#fff' : '#101111'}}></span>
        </div>
    </div>
    </div>
    <div style={{top: mobileMenu ? navbarHeight : '-341px', backgroundColor: darkMode ? '#fff' : '#101111'}} className={`mobile-menu ${mobileMenu ? 'mobile-menu-visible' : 'mobile-menu-hidden'}`}>
        <a style={{color: darkMode ? '#000' : '#fff'}} href="/">About</a>
        <a style={{color: darkMode ? '#000' : '#fff'}} href="/">Collection</a>
        <a style={{color: darkMode ? '#000' : '#fff'}} href="/">FAQs</a>
        <WalletDialogButton>
            Connect wallet
        </WalletDialogButton>
        <div className="mobile-menu-social">
            <a style={{color: darkMode ? '#000' : '#fff'}} href="/">
                <FaTwitter size={25}/>
            </a>
            <a style={{color: darkMode ? '#000' : '#fff'}} href="/">
                <FaDiscord size={25}/>
            </a>
            <button onClick={() => setGlobalState('darkMode', !darkMode)}>
                <img style={{filter: darkMode ? '' : 'invert(94%) sepia(100%) saturate(23%) hue-rotate(3deg) brightness(106%) contrast(107%)'}} src={sun} alt="light-mode" />
            </button>
        </div>
    </div>
    </div>
  )
}

export default NavbarNew